import moment from 'moment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SystemService, SystemServiceFactory } from '../../service/system.service';
import { HWServiceConfig } from '../../service/hw-service-config';
import { AppContext } from '../../base/control/context';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY HH:mm:ss',
  },
  display: {
    dateInput: 'DD.MM.YYYY HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD.MM.YYYY HH:mm:ss',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'lib-date-setting',
  templateUrl: './date-setting.component.html',
  styleUrls: ['./date-setting.component.scss'],
  providers: [{ provide: NGX_MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class DateSettingComponent implements OnInit {
  @ViewChild('picker') picker: any;
  date: moment.Moment;
  dateControl = new FormControl(moment());
  canChangeDate = false;
  private newDateTime: moment.Moment;
  stepHour = 1;
  stepMinute = 1;
  private interval: any;
  private dead: ReplaySubject<void> = new ReplaySubject();
  private settingsService: SystemService;

  constructor(private settingsServiceFactory: SystemServiceFactory, private config: HWServiceConfig, private appContext: AppContext) {
    this.settingsService = this.settingsServiceFactory.create(this.config);
  }

  ngOnInit(): void {
    this.timeCounter();
    this.settingsService.connect().subscribe();
  }

  private timeCounter(): void {
    this.canChangeDate = false;
    this.interval = setInterval(() => {
      this.dateControl = new FormControl(moment());
    }, 1000);
  }

  public detectDateChange(_event: any) {
    const event = _event as MatDatepickerInputEvent<moment.Moment>;
    this.newDateTime = moment(event.value, 'DD.MM.YYYY HH:mm:ss');
    this.dateControl = new FormControl(moment(event.value));
    this.canChangeDate = true;
    clearInterval(this.interval);
    this.interval = undefined;
  }

  public changeDateTime() {
    if (this.newDateTime.isValid()) {
      const v =
        this.newDateTime.year().toString().padStart(4, '0') +
        '-' +
        (this.newDateTime.month() + 1).toString().padStart(2, '0') +
        '-' +
        this.newDateTime.date().toString().padStart(2, '0') +
        ' ' +
        this.newDateTime.hour().toString().padStart(2, '0') +
        ':' +
        this.newDateTime.minute().toString().padStart(2, '0') +
        ':' +
        this.newDateTime.second().toString().padStart(2, '0');
      this.canChangeDate = false;
      this.settingsService
        .setTime(v)
        .pipe(takeUntil(this.dead))
        .subscribe(
          (r) => {
            this.appContext.getMessageSink()('INFO', 'settings.date.success');
            this.timeCounter();
          },
          (e) => {
            this.appContext.getMessageSink()('ERROR', 'settings.date.error');
            this.timeCounter();
          },
        );
    } else {
      this.appContext.getMessageSink()('ERROR', 'INVALID.DT');
      this.timeCounter();
    }
  }

  i18nString(key: string): string {
    return this.appContext.getI18NString(key);
  }

  ngOnDestroy(): void {
    this.dead.next();
    this.dead.complete();
    clearInterval(this.interval);
    this.interval = undefined;
    this.settingsService.disconnect().subscribe();
  }
}
